import axios from 'axios'
const baseurl = process.env.REACT_APP_API_URL

export const createUser = async data => {
  try {
    const response = await axios({
      method: 'post',
      url: baseurl + `/vendorRegister`,
      data: data
    })
    return response.data
  } catch (error) {
    console.log(error)
  }
}
